import React from 'react';
import { deleteRecruitmentMessageData, getRecruitmentMessageData } from '../../service/adminApi';
import { getTimestampToDate } from '../../utils/dateConvetor';
import '../Leave/offboard.css';
import '../Leave/Leave.css';
import Popup from '../../components/ConformationPopup/Popup';

function RejectionMessage({ updateData, editData }) {
    const [rejectionMessageList, setRejectionMessageList] = React.useState([]);
    const [flag, setFlag] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState();

    React.useEffect(() => {
        getRejectionMessage();
    }, []);

    React.useEffect(() => {
        if (updateData !== undefined) {
            updateRejectionDetails(updateData);
        }
    }, [updateData]);

    const getRejectionMessage = async () => {
        let data = {
            message_type: 'rejection',
        };
        const response = await getRecruitmentMessageData(data);

        setRejectionMessageList(response.data.data);
    };

    const updateRejectionDetails = (data) => {

        switch (data) {
            case 'cancel':
                break;
            case 'update':

                getRejectionMessage();
                break;
            default:
                break;
        }
    };

    const deleteRejectionMessage = async () => {
        let data = {
            id: rejectionMessageList[deleteIndex].id,
            is_active: false,
        };
        const response = await deleteRecruitmentMessageData(data);
        if (response.data.statusCode === 200) {
            let array = rejectionMessageList;
            let arr = array.splice(deleteIndex, 1);
            let updatedData = array;
            setRejectionMessageList(updatedData);
            setFlag(!flag);
        }
    };

    const renderRejectionMessage = () => {
        if (rejectionMessageList.length > 0) {
            return rejectionMessageList.map((rejectionMessage, index) => {
                let joinDate = getTimestampToDate(rejectionMessage.modified_at, 3);
                return (
                    <div className="col-md-3 mt-4 mb-3">
                        <div className="card admin-card-styles border-0 ">
                            <div
                                className="admin-offboard-bg-holder admin-offboard-bg-card admin-offboard-bg-image"
                                style={{
                                    backgroundImage: 'url(/Images/card-bg.svg)',
                                }}
                            />
                            {/*/.bg-holder*/}
                            <div className="card-body position-relative mt-3">
                                <h6 className="bold-text font-12 mb-4">{rejectionMessage.title}</h6>
                                <p className="regular-text font-12 mb-1 offboard-card-text-trunc">{rejectionMessage.description}</p>
                                <p className="medium-text font-10 admin-offboard-dateupdate">Last Updated : {joinDate}</p>
                            </div>
                            <div class="card-kebab-position">
                                <img data-bs-toggle="dropdown" aria-expanded="false" src="/Images/card_edit.svg" alt="Icon" />

                                <ul className="dropdown-menu dropdown-menu-end offboarding-card-dropdown border-0 shadow-sm">
                                    <li>
                                        <a
                                            className="dropdown-item border-bottom dditems semibold-text font-12 touchbase-kebabitems-color"
                                            type="button"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasRight"
                                            aria-controls="offcanvasRight"
                                            onClick={() => {
                                                // setEditRejectionMessage(rejectionMessageList[index]);
                                                editData(rejectionMessageList[index]);
                                            }}
                                        >
                                            Edit
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color"
                                            data-bs-toggle="modal"
                                            data-bs-target="#rejectionMessage"
                                            onClick={() => {
                                                setDeleteIndex(index);
                                            }}
                                        >
                                            Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <Popup
                            deleteData={() => {
                                deleteRejectionMessage();
                            }}
                            ID="rejectionMessage"
                        />
                    </div>
                );
            });
        } else {
            return (
                <div className="row justify-content-center  w-100">
                    <img src="/Images/nodatafound.png" alt="no-records" style={{ width: 700, height: 500 }} />
                    <span className="row justify-content-center tt-bold font-16">No Rejection Message</span>
                </div>
            );
        }
    };

    return (
        <div class="tab-pane fade mt-4" id="my_leave_request" role="tabpanel" aria-labelledby="all_leave_request_tab">
            <div className="row">{renderRejectionMessage()}</div>
        </div>
    );
}

export default RejectionMessage;
